export default {
  path: ":alias/honours",
  component: resolve => require(["@/views/honours"], resolve),
  children: [
    {
      path: "list",
      component: resolve => require(["@/views/honours/list"], resolve)
    }
  ]
};
